module.exports = '/ng-templates/modals/loan-request-form/templates/mvs-requestability.tpl.ftl';
